import { Injectable } from '@angular/core';
import { AdminService } from '@admin/services/admin.service';

@Injectable({
  providedIn: 'root',
})
export class RolesResolver {
  constructor(private admin: AdminService) {}

  public resolve() {
    return this.admin.getRoles();
  }
}
